import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { SendPushNotificationFormAdvancedOptionsSection } from './SendPushNotificationFormAdvancedOptionsSection';
import { SendPushNotificationFormMainSection } from './SendPushNotificationFormMainSection';

export type ISendPushNotificationFormValues = {
  title?: string;
  content?: string;
  target?: string;
  targetValue?: 'feed' | 'article' | 'userArticle' | 'chatRoomId' | 'url';
  hideNavbar?: boolean;
};

export type ISendPushNotificationFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ISendPushNotificationFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<ISendPushNotificationFormValues>;
    onSubmit?: SubmitHandler<ISendPushNotificationFormValues>;
    estimatedReachCount?: number;
  };

export const SendPushNotificationForm: React.FC<
  ISendPushNotificationFormProps
> = (props) => {
  const { defaultValues, ...other } = props;

  const form = useForm<ISendPushNotificationFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody form={form} {...other}>
      <SendPushNotificationFormMainSection form={form} />
      <SendPushNotificationFormAdvancedOptionsSection form={form} />
    </ContentBlock.FormBody>
  );
};
